// extracted by mini-css-extract-plugin
export default {"secondaryFont":"ItemDeskop_secondaryFont__9c2sk","primaryFont":"ItemDeskop_primaryFont__pKkZQ"};